<hawk-record-navigation [breadcrumbLinkList]="[]" [root]="'customer'" [leafDescription]="'Kunden'" class="app-page">
  <div slot="toolbar" class="flex flex-row gap-2">
    <a href="/a/kunde/neu" class="bm-btn">
      <i class="fa fa-plus"></i>
      Neuer Kunde
    </a>
    <input type="text" class="bm-input" placeholder="Schnellfilter..." (input)="quickSearchChanged($event)" />
  </div>
  <div class="page-content page-frame">
    <ag-grid-angular
      class="ag-theme-quartz h-full"
      [rowData]="shownCustomers"
      [theme]="hawkTheme"
      [defaultColDef]="defaultColDef"
      [columnDefs]="colDefs"
      [rowClassRules]="rowClassRules"
      [pagination]="true"
      [rowSelection]="rowSelection"
      [autoSizeStrategy]="autoSizeStrategy"
      [paginationPageSize]="100"
      [localeText]="locale"
      [sideBar]="sideBarOptions"
      [paginationPageSizeSelector]="[25, 100, 250, 1000]"
      (gridReady)="onGridReady($event)"
    />
  </div>
</hawk-record-navigation>
